<link href="/src/styles.scss" type="text/scss" rel="stylesheet" />
<div class="dialog">
    <h1>{{ title | translate }}</h1>
    <span [innerHTML]="message | translate: param"></span> <br>
    @if(complement){
      <span [innerHTML]="complement | translate"></span>
    }
    <div fxLayoutAlign="end" fxLayoutGap="1%">
        <button
                mat-flat-button
                mat-dialog-close
                (click)="reload()"
                class="button close"
        >
            <mat-icon>
                close
            </mat-icon>
            {{ "button.close" | translate }}
        </button>
    </div>
</div>
